import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ConfirmNewsletter() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ loading: false, ok: false, msg: "Missing confirmation token." }); return; }
    api.post("/newsletter/confirm", { token })
      .then((r) => setState({ loading: false, ok: true, msg: r.data.message }))
      .catch((e) => setState({ loading: false, ok: false, msg: formatApiError(e.response?.data?.detail) }));
  }, [params]);

  return (
    <div className="mx-auto max-w-lg px-6 py-24 text-center" data-testid="confirm-newsletter">
      {state.loading ? (
        <p className="text-mutedplum">Confirming your subscription…</p>
      ) : (
        <>
          <span className={`inline-flex h-16 w-16 items-center justify-center rounded-full mx-auto ${state.ok ? "bg-teal text-white" : "bg-rose/50 text-plum"}`}>
            {state.ok ? <Check className="h-8 w-8" /> : <X className="h-8 w-8" />}
          </span>
          <h1 className="mt-6 font-display text-3xl text-plum">{state.ok ? "You're in!" : "Hmm, that link didn't work"}</h1>
          <p className="mt-3 text-mutedplum text-lg">{state.msg}</p>
          <Link to="/" className="mt-8 inline-block rounded-full bg-teal px-7 py-3 font-semibold text-white hover:bg-teal-dark transition-colors">Back to home</Link>
        </>
      )}
    </div>
  );
}
